export default "__VITE_ASSET__DExqWkio__"